function Card(props) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`!z-5 relative flex flex-col rounded-[20px] bg-whiteColor dark:bg-sidebar bg-clip-border shadow-2xl shadow-gray-200 dark:text-white dark:!shadow-none ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
